import { gql as gqlFn } from '@apollo/client';
export * from './ApiContext';
export * from './useApi';

export const gql = gqlFn;
